import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Edit14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_89)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.3839 1.32321C10.8957 0.835052 10.1042 0.835054 9.61609 1.32321L1.83223 9.10708L0.840647 12.5776C0.652059 13.2377 1.2623 13.8479 1.92236 13.6593L5.39289 12.6677L13.1768 4.88387C13.6649 4.39571 13.6649 3.60426 13.1768 3.1161L11.3839 1.32321ZM9.56067 3.49995L10.5 2.56065L11.9393 3.99999L11 4.93929L9.56067 3.49995ZM8.50001 4.56061L3.16773 9.89289L2.59199 11.908L4.60707 11.3322L9.93935 5.99995L8.50001 4.56061Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_89'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Edit14.displayName = 'Edit14';
export default Edit14;
